// @ts-nocheck
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import PromptLoginComponent from './component';

interface PromptLoginModalProps {
  onClose?: () => void;
  onHidePopup?: () => void;
  shouldRedirect?: boolean;
  [key: string]: any;
}

/**
 * Modal wrapper for PromptLogin to work with the new modal manager system
 * Bridges onClose (new modal system) with handleLoginSuccess (legacy PromptLogin API)
 */
const PromptLoginModal = ({ onClose, onHidePopup, shouldRedirect = true, ...otherProps }: PromptLoginModalProps) => {
  const handleLoginSuccess = useCallback(() => {
    // Close the modal after successful login
    if (onClose) {
      onClose();
    } else if (onHidePopup) {
      onHidePopup();
    }
  }, [onClose, onHidePopup]);

  // PromptLogin needs Redux state - get it here and pass as props
  const isInitialSsrPage = useSelector((state: any) => state.app.isInitialSsrPage);
  const pathname = useSelector((state: any) => state.location.current.pathname);
  const user = useSelector((state: any) => state.user);

  return (
    <PromptLoginComponent
      handleLoginSuccess={handleLoginSuccess}
      shouldRedirect={shouldRedirect}
      isInitialSsrPage={isInitialSsrPage}
      pathname={pathname}
      user={user}
      {...otherProps}
    />
  );
};

export default PromptLoginModal;
